import { asyncify, Cookies } from '../../utilities';
import { goFetch } from '../../utilities/goFetch';
import { roleDataService } from '../../_modules/roles/services';
import { publish } from '../../hooks';
import { StateTopicEnum } from '../../enums';
import config from '../../_config/global';

interface LoginArgs {
  username: string;
  password: string;
}

interface GetProfileArgs {
  username: string;
}

class Service {
  checkAuthentication = async () => {
    return asyncify(() => {
      const data = localStorage.getItem('h-user');
      if (!data) return null;
      var user = JSON.parse(data);
      this.setUserPermissions(user?.user_roles);
      return user;
    }, 100);
  };

  login = async ({ username, password }: LoginArgs) => {
    var response: any = await goFetch('/account/login')
      .withBody({
        email_address: username,
        password: password,
        admin_right: true
      })
      .post();

    if (response.success && response.data.user) {
      localStorage.setItem('h-user', JSON.stringify(response.data.user));

      Cookies.setCookie({
        name: 'token',
        value: response.data.token,
        days: 30
      });

      this.setUserPermissions(response.data.user.user_roles);
      return response.data.user;
    }

    return false;
  };

  async logout() {
    return await asyncify(() => {
      localStorage.clear();
      sessionStorage.clear();
      Cookies.setCookie({ name: 'token', value: '' });
    }, 100);
  }

  async getProfile({ username }: GetProfileArgs) {
    return await asyncify(() => {}, 400);
  }

  setUserPermissions = async (userPermissions: string[]) => {
    let roles: any[] = [];
    await roleDataService.getRoles(true).then(function (data) {
      roles = data;
    });

    if (roles?.length) {
      roles = roles.filter(
        (role) =>
          role?.is_active &&
          Array.isArray(role?.permissions) &&
          userPermissions?.includes(role?._id)
      );
      let assignedPermissions: string[] = [];
      roles.forEach((role) => {
        assignedPermissions = assignedPermissions.concat(role.permissions);
      });
      publish(StateTopicEnum.CurrentUserRoles, '');
      if (!assignedPermissions) return;
      sessionStorage.setItem(
        'user-access',
        JSON.stringify([...new Set(assignedPermissions)])
      );
    }

    return false;
  };

  checkRoleAccess(role: string) {
    if (!role) return false;
    const rolesLocal = sessionStorage.getItem('user-access');
    if (this.getCurrentUserEmail() === 'appletester@cardcurator.com')
      return true;
    else if (!rolesLocal) {
      return false;
    }

    const roles = JSON.parse(rolesLocal);

    if (!Array.isArray(roles) || roles?.length < 1) return false;
    if (roles[0].trim() === '') return false;

    return roles?.includes(role);
  }

  getUserInfluencerLinks() {
    var user = localStorage.getItem('h-user');
    let influencer_links = [];
    if (user) influencer_links = JSON.parse(user)?.influencer_links;
    return influencer_links ? influencer_links : [];
  }

  getAllUserInfluencerLinks = async () => {
    const links = (await goFetch(
      config.endpoints.users.influencerLinks
    ).get()) as any;
    return links?.data;
  };

  getCurrentUserEmail() {
    var user = localStorage.getItem('h-user');
    return user && JSON.parse(user)?.email_address
      ? JSON.parse(user).email_address
      : '';
  }
}

export default new Service();
